import {
  Chip,
  Container,
  Typography,
  spacing3,
  spacing5,
} from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getSellerNavData } from '../../../../store/actions/storefrontActions';
import FavoriteToggle from '../../FavoriteToggle';
import { PageHeaderInfoWrapper } from './PageHeaderInfo.styles';

const PageHeaderInfo = ({
  description,
  hasFavorite,
  imgSrc,
  isFavorite,
  showDirectPayBadge,
  slug,
  title,
  vendorId,
}) => {
  const dispatch = useDispatch();

  const handleFavoriteToggleSuccess = () => {
    dispatch(
      getSellerNavData({
        slug,
      })
    );
  };

  return (
    <PageHeaderInfoWrapper>
      {imgSrc && <img alt={title} src={imgSrc} />}
      <div>
        <Container sx={{ gap: spacing5, alignItems: 'center' }}>
          <Typography
            component='h4'
            testingId='page-header-info--title--typography-h4'
          >
            {title}
          </Typography>
          {showDirectPayBadge && (
            <Chip color='seafoam' size='small' text='Direct Pay Available' />
          )}
        </Container>
        {description && (
          <Typography
            component='p'
            testingId='page-header-info--description--typography-p'
            sx={{
              marginTop: spacing3,
            }}
          >
            {description}
          </Typography>
        )}
      </div>
      {hasFavorite && (
        <FavoriteToggle
          isFavorite={isFavorite}
          onSuccess={handleFavoriteToggleSuccess}
          vendorId={vendorId}
        />
      )}
    </PageHeaderInfoWrapper>
  );
};

PageHeaderInfo.defaultProps = {
  description: null,
  hasFavorite: false,
  imgSrc: null,
  isFavorite: false,
  showDirectPayBadge: false,
  slug: null,
  vendorId: null,
};

PageHeaderInfo.propTypes = {
  description: PropTypes.string,
  hasFavorite: PropTypes.bool,
  imgSrc: PropTypes.string,
  isFavorite: PropTypes.bool,
  showDirectPayBadge: PropTypes.bool,
  slug: PropTypes.string,
  title: PropTypes.string.isRequired,
  vendorId: PropTypes.number,
};

export default PageHeaderInfo;
